module.exports = __webpack_public_path__ + "static/media/logo.52816de3.png";